export default "__VITE_ASSET__DFB5xi4D__"